import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";
import { useHunchRoomFlag } from "./flag";

/**
 * Mục "Phòng máy": quyền thô `hunchroom.enter` (Quản trị / Giám đốc) VÀ máy chủ
 * đã bật phòng VÀ có tên trong phòng. Cổng thật là danh sách tên ở máy chủ
 * (CEO chốt 2a); có quyền mà không có tên thì mục ẩn, không để bấm vào rồi ăn 403.
 */
export function canEnterHunchRoom(): boolean {
  const f = useHunchRoomFlag.getState();
  return hasPermission(ACTION.HunchRoomEnter) && f.enabled && f.isMember;
}
